import { Invalid, Invalids, OptionSelectDefault, Paginacao } from 'models/types'

export enum TYPES {
  SET_ACTIVE_TAB = '@@configuracaoKanban/SET_ACTIVE_TAB',
  SET_CONFIGURACAO_KANBAN = '@@configuracaoKanban/SET_CONFIGURACAO_KANBAN',
  SET_PIPELINES_TAB_ETAPAS = '@@configuracaoKanban/SET_PIPELINES_TAB_ETAPAS',
  CLEAN_PIPELINES_TAB_ETAPAS = '@@configuracaoKanban/CLEAN_PIPELINES_TAB_ETAPAS',
  SET_ETAPAS_PIPELINES_TAB_ETAPAS = '@@configuracaoKanban/SET_ETAPAS_PIPELINES_TAB_ETAPAS',
  CLEAN_ETAPAS_PIPELINES_TAB_ETAPAS = '@@configuracaoKanban/CLEAN_ETAPAS_PIPELINES_TAB_ETAPAS',
  SET_REGISTER_TAB_ETAPAS = '@@configuracaoKanban/SET_REGISTER_TAB_ETAPAS',
  SET_REGISTER_FIELDS_TAB_ETAPAS = '@@configuracaoKanban/SET_REGISTER_FIELDS_TAB_ETAPAS',
  SET_REGISTER_ETAPAS_PERMITIDAS_TAB_ETAPAS = '@@configuracaoKanban/SET_REGISTER_ETAPAS_PERMITIDAS_TAB_ETAPAS',
  CLEAN_REGISTER_TAB_ETAPAS = '@@configuracaoKanban/CLEAN_REGISTER_TAB_ETAPAS',
  SET_INVALIDS_FIELDS_REGISTER_TAB_ETAPAS = '@@configuracaoKanban/SET_INVALIDS_FIELDS_REGISTER_TAB_ETAPAS',
  CLEAN_INVALIDS_REGISTER_TAB_ETAPAS = '@@configuracaoKanban/CLEAN_INVALIDS_REGISTER_TAB_ETAPAS',
  SET_ETAPAS_PERMITIDAS_TAB_ETAPAS = '@@configuracaoKanban/SET_ETAPAS_PERMITIDAS_TAB_ETAPAS',
  SET_VISUALIZACAO_TAB_ETAPAS = '@@configuracaoKanban/SET_VISUALIZACAO_TAB_ETAPAS',
  SET_PIPELINE_SELECIONADO_TAB_ETAPAS = '@@configuracaoKanban/SET_PIPELINE_SELECIONADO_TAB_ETAPAS',
  SET_ETAPA_PIPELINE_SELECIONADO_TAB_ETAPAS = '@@configuracaoKanban/SET_ETAPA_PIPELINE_SELECIONADO_TAB_ETAPAS',
  SET_BIGNUMBERS_TAB_SLAS = '@@configuracaoKanban/SET_BIGNUMBERS_TAB_SLAS',
  SET_REGISTER_TAB_SLAS = '@@configuracaoKanban/SET_REGISTER_TAB_SLAS',
  SET_REGISTER_FIELDS_TAB_SLAS = '@@configuracaoKanban/SET_REGISTER_FIELDS_TAB_SLAS',
  SET_REGISTER_REGRAS_ESCALACAO_TAB_SLAS = '@@configuracaoKanban/SET_REGISTER_REGRAS_ESCALACAO_TAB_SLAS',
  ADICIONAR_REGISTER_REGRAS_ESCALACAO_TAB_SLAS = '@@configuracaoKanban/ADICIONAR_REGISTER_REGRAS_ESCALACAO_TAB_SLAS',
  REMOVER_REGISTER_REGRAS_ESCALACAO_TAB_SLAS = '@@configuracaoKanban/REMOVER_REGISTER_REGRAS_ESCALACAO_TAB_SLAS',
  CLEAN_REGISTER_TAB_SLAS = '@@configuracaoKanban/CLEAN_REGISTER_TAB_SLAS',
  SET_INVALIDS_REGISTER_TAB_SLAS = '@@configuracaoKanban/SET_INVALIDS_REGISTER_TAB_SLAS',
  SET_INVALIDS_FIELDS_REGISTER_TAB_SLAS = '@@configuracaoKanban/SET_INVALIDS_FIELDS_REGISTER_TAB_SLAS',
  SET_INVALIDS_FIELDS_REGISTER_ARRAY_TAB_SLAS = '@@configuracaoKanban/SET_INVALIDS_FIELDS_REGISTER_ARRAY_TAB_SLAS',
  CLEAN_INVALIDS_REGISTER_TAB_SLAS = '@@configuracaoKanban/CLEAN_INVALIDS_REGISTER_TAB_SLAS',
  SET_PIPELINES_TAB_SLAS = '@@configuracaoKanban/SET_PIPELINES_TAB_SLAS',
  SET_ETAPAS_TAB_SLAS = '@@configuracaoKanban/SET_ETAPAS_TAB_SLAS',
  SET_ACOES_TAB_SLAS = '@@configuracaoKanban/SET_ACOES_TAB_SLAS',
  SET_VISUALIZACAO_TAB_SLAS = '@@configuracaoKanban/SET_VISUALIZACAO_TAB_SLAS',
  SET_SLAS_CONFIGURADOS_TAB_SLAS = '@@configuracaoKanban/SET_SLAS_CONFIGURADOS_TAB_SLAS',
  CLEAN_SLAS_CONFIGURADOS_TAB_SLAS = '@@configuracaoKanban/CLEAN_SLAS_CONFIGURADOS_TAB_SLAS',
  SET_PIPELINES_TAB_PIPELINES = '@@configuracaoKanban/SET_PIPELINES_TAB_PIPELINES',
  SET_PAGINATION_TAB_PIPELINES = '@@configuracaoKanban/SET_PAGINATION_TAB_PIPELINES',
  CLEAN_PIPELINES_TAB_PIPELINES = '@@configuracaoKanban/CLEAN_PIPELINES_TAB_PIPELINES',
  SET_REGISTER_TAB_PIPELINES = '@@configuracaoKanban/SET_REGISTER_TAB_PIPELINES',
  SET_REGISTER_FIELDS_TAB_PIPELINES = '@@configuracaoKanban/SET_REGISTER_FIELDS_TAB_PIPELINES',
  CLEAN_REGISTER_TAB_PIPELINES = '@@configuracaoKanban/CLEAN_REGISTER_TAB_PIPELINES',
  SET_VISUALIZACAO_TAB_PIPELINES = '@@configuracaoKanban/SET_VISUALIZACAO_TAB_PIPELINES',
  SET_INVALIDS_FIELDS_REGISTER_TAB_PIPELINES = '@@configuracaoKanban/SET_INVALIDS_FIELDS_REGISTER_TAB_PIPELINES',
  CLEAN_INVALIDS_REGISTER_TAB_PIPELINES = '@@configuracaoKanban/CLEAN_INVALIDS_REGISTER_TAB_PIPELINES',
  SET_PIPELINE_SELECIONADO_TAB_PIPELINES = '@@configuracaoKanban/SET_PIPELINE_SELECIONADO_TAB_PIPELINES',
  CLEAN_PIPELINE_SELECIONADO_TAB_PIPELINES = '@@configuracaoKanban/CLEAN_PIPELINE_SELECIONADO_TAB_PIPELINES',
  SET_ETAPAS_TAB_PIPELINES = '@@configuracaoKanban/SET_ETAPAS_TAB_PIPELINES',
  CLEAN_ETAPAS_TAB_PIPELINES = '@@configuracaoKanban/CLEAN_ETAPAS_TAB_PIPELINES',
  SET_SEARCH_TAB_PIPELINES = '@@configuracaoKanban/SET_SEARCH_TAB_PIPELINES',
  CLEAN_SEARCH_TAB_PIPELINES = '@@configuracaoKanban/CLEAN_SEARCH_TAB_PIPELINES',
  SET_MODAL_REGISTER_IS_OPEN_PIPELINES = '@@configuracaoKanban/SET_MODAL_REGISTER_IS_OPEN_PIPELINES',
  SET_OPTIONS_SELECT_TAB_PIPELINES = '@@configuracaoKanban/SET_OPTIONS_SELECT_TAB_PIPELINES',

  GET_CONFIGURACAO_KANBAN_SAGA = '@@configuracaoKanban/GET_CONFIGURACAO_KANBAN_SAGA',
  GET_PIPELINES_TAB_ETAPAS_SAGA = '@@configuracaoKanban/GET_PIPELINES_TAB_ETAPAS_SAGA',
  GET_ETAPAS_PIPELINE_TAB_ETAPAS_SAGA = '@@configuracaoKanban/GET_ETAPAS_PIPELINE_TAB_ETAPAS_SAGA',
  GET_ETAPA_BY_ID_TAB_ETAPAS_SAGA = '@@configuracaoKanban/GET_ETAPA_BY_ID_TAB_ETAPAS_SAGA',
  GET_ETAPAS_PERMITIDAS_TAB_ETAPAS_SAGA = '@@configuracaoKanban/GET_ETAPAS_PERMITIDAS_TAB_ETAPAS_SAGA',
  SALVAR_ETAPA_TAB_ETAPAS_SAGA = '@@configuracaoKanban/SALVAR_ETAPA_TAB_ETAPAS_SAGA',
  EDITAR_ETAPA_TAB_ETAPAS_SAGA = '@@configuracaoKanban/EDITAR_ETAPA_TAB_ETAPAS_SAGA',
  REMOVER_ETAPA_TAB_ETAPAS_SAGA = '@@configuracaoKanban/REMOVER_ETAPA_TAB_ETAPAS_SAGA',
  ALTERAR_ORDEM_ETAPA_TAB_ETAPAS_SAGA = '@@configuracaoKanban/ALTERAR_ORDEM_ETAPA_TAB_ETAPAS_SAGA',
  GET_BIGNUMBERS_TAB_SLAS_SAGA = '@@configuracaoKanban/GET_BIGNUMBERS_TAB_SLAS_SAGA',
  GET_SLA_BY_ID_TAB_SLAS_SAGA = '@@configuracaoKanban/GET_SLA_BY_ID_TAB_SLAS_SAGA',
  GET_PIPELINES_TAB_SLAS_SAGA = '@@configuracaoKanban/GET_PIPELINES_TAB_SLAS_SAGA',
  GET_ETAPAS_TAB_SLAS_SAGA = '@@configuracaoKanban/GET_ETAPAS_TAB_SLAS_SAGA',
  GET_ACOES_TAB_SLAS_SAGA = '@@configuracaoKanban/GET_ACOES_TAB_SLAS_SAGA',
  SALVAR_SLA_TAB_SLAS_SAGA = '@@configuracaoKanban/SALVAR_SLA_TAB_SLAS_SAGA',
  EDITAR_SLA_TAB_SLAS_SAGA = '@@configuracaoKanban/EDITAR_SLA_TAB_SLAS_SAGA',
  GET_SLAS_CONFIGURADOS_TAB_SLAS_SAGA = '@@configuracaoKanban/GET_SLAS_CONFIGURADOS_TAB_SLAS_SAGA',
  REMOVER_SLA_CONFIGURADO_TAB_SLAS_SAGA = '@@configuracaoKanban/REMOVER_SLA_CONFIGURADO_TAB_SLAS_SAGA',
  GET_PIPELINES_TAB_PIPELINES_SAGA = '@@configuracaoKanban/GET_PIPELINES_TAB_PIPELINES_SAGA',
  GET_PIPELINE_BY_ID_TAB_PIPELINES_SAGA = '@@configuracaoKanban/GET_PIPELINE_BY_ID_TAB_PIPELINES_SAGA',
  EDITAR_PIPELINE_TAB_PIPELINES_SAGA = '@@configuracaoKanban/EDITAR_PIPELINE_TAB_PIPELINES_SAGA',
  SALVAR_PIPELINE_TAB_PIPELINES_SAGA = '@@configuracaoKanban/SALVAR_PIPELINE_TAB_PIPELINES_SAGA',
  REMOVER_PIPELINE_TAB_PIPELINES_SAGA = '@@configuracaoKanban/REMOVER_PIPELINE_TAB_PIPELINES_SAGA',
  ALTERAR_STATUS_PIPELINE_TAB_PIPELINES_SAGA = '@@configuracaoKanban/ALTERAR_STATUS_PIPELINE_TAB_PIPELINES_SAGA',
  DUPLICAR_PIPELINE_TAB_PIPELINES_SAGA = '@@configuracaoKanban/DUPLICAR_PIPELINE_TAB_PIPELINES_SAGA',
  GET_CENTROS_CUSTO_TAB_PIPELINES_SAGA = '@@configuracaoKanban/GET_CENTROS_CUSTO_TAB_PIPELINES_SAGA'
}

export interface CONFIGURACAO_KANBAN {
  activeTab: number
  tabEtapas: TabEtapas
  tabSLAs: TabSLAs
  tabPipelines: TabPipelines
}

interface TabEtapas {
  pipelines: PipelineTabEtapas[]
  etapasPipeline: EtapasPipeline[]
  register: RegisterEtapas | null
  invalids: InvalidsRegisterEtapas
  etapasPermitidas: EtapasPermitidas[]
  visualizacao: boolean
  pipelineSelecionado: string | null
  etapaPipelineSelecionado: string | null
}

interface PipelineTabEtapas {
  id: string
  nome: string
  descricao: string
  ativo: boolean
  dataCriacao: string
  quantidadeLeads: number
  etapas: {
    id: string
    nome: string
    descricao: string
    ordem: number
  }[]
}

interface EtapasPipeline {
  id: string
  descricao: string
  ordem: number
  nome: string
  cor: string
  status: boolean
  etapasPermitidas: {
    nome: string
    etapaId: string
  }[]
}

export interface RegisterEtapas {
  id?: string
  nome: string
  descricao: string
  cor: string
  etapasPermitidas: string[]
  pipelineId: string
  status: boolean
}

export type InvalidsRegisterEtapas = {
  [K in keyof RegisterEtapas]: Invalid
}

interface EtapasPermitidas {
  id: string
  descricao: string
  cor: string
  nome: string
  ordem: number
  status: boolean
}

interface TabSLAs {
  bigNumbers: BigNumbers
  slasConfigurados: SLAConfigurado[]
  register: RegisterSLAs | null
  invalids: InvalidsRegisterSLAs
  pipelines: PipelineSLAs[]
  etapas: EtapaSLAs[]
  acoes: AcaoSLAs[]
  visualizacao: boolean
}

interface BigNumbers {
  prazosAtendimentosAtivos: number
  emAtrasoAtivos: number
}

export interface RegisterSLAs {
  id?: string | null
  nome: string
  descricao: string
  pipelineId: string
  pipelineEtapaId: string
  prazo: number
  regrasEscalacao: RegraEscalacao[]
}

export type InvalidsRegisterSLAs = Invalids<RegisterSLAs> & {
  regrasEscalacaoMessage: Invalid
}

interface PipelineSLAs {
  id: string
  descricao: string
}

interface EtapaSLAs {
  id: string
  descricao: string
  corEtapa: string
}

interface AcaoSLAs {
  id: string
  descricao: string
}

export interface RegraEscalacao {
  id?: string | null
  disparaEm: string
  acaoId: string
  mensagem: string
}

interface SLAConfigurado {
  id: string
  nome: string
  descricao: string
  pipelineId: string
  pipelineEtapaId: string
  descricaoEtapa: string
  prazo: number
  etapaAtiva: boolean
  emDia: string
  alerta: string
  atrasado: string
  regraEscalacao: RegraEscalacao[]
}

interface TabPipelines {
  pipelines: PipelineTabPipeline[]
  pagination: Paginacao
  register: RegisterPipelines | null
  invalids: InvalidsRegisterPipelines
  search: SearchPipelines
  modalRegisterIsOpen: boolean
  pipelineSelecionado: string | null
  visualizacao: boolean
  optionsSelect: OptionsSelectPipelines
}

export interface PipelineTabPipeline {
  id: string
  centroCustoId: string
  nome: string
  descricao: string
  dataCriacao: string
  quantidadeLeads: number
  etapas: EtapasPipelineTabPipeline[]
  ativo: boolean
  status: boolean
  site: boolean
}

interface EtapasPipelineTabPipeline {
  id: string
  nome: string
  descricao: string
  ordem: number
}

export interface RegisterPipelines {
  id?: string
  nomePipeline: string
  descricao: string
  centroCustoId: string
  quantidadeLeads?: number
  site: boolean
}

export type InvalidsRegisterPipelines = Invalids<RegisterPipelines>

interface SearchPipelines {
  status: boolean | null
  nome: string
}

interface OptionsSelectPipelines {
  centrosCusto: OptionSelectDefault[]
}
